// import 'normalize.css';
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


 
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Buffer } from 'buffer';
import { initializeAmplify } from './components/aws-config';

window.global = window;
window.Buffer = Buffer;

const token = localStorage.getItem("token");

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

if (token) {
  initializeAmplify(token)
    .then(renderApp)
    .catch((err) => {
      console.error("Amplify init failed:", err);
      // Optionally show fallback error UI
      renderApp(); // Still render app, maybe show login or error screen
    });
} else {
  console.warn("No token found. Redirecting or showing login...");
  renderApp(); // Possibly redirect to login  
}

reportWebVitals();
